
import Content from '@/mixins/content.js'
import PageTransitionGuard from '@/mixins/pageTransitionGuard.js'

export default {
  layout: 'default',
  name: 'PagesRouteCatchAll',

  mixins: [Content, PageTransitionGuard],

  mounted() {
    this.$store.commit('nav/setMountedKey')
  },
}
